import { render, staticRenderFns } from "./InjectableAppointmentsWidget.vue?vue&type=template&id=4a3f77aa&"
import script from "./InjectableAppointmentsWidget.vue?vue&type=script&lang=js&"
export * from "./InjectableAppointmentsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports